// @flow
import Tabletop from 'tabletop'
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { VideoPlayer } from 'components/videoplayer'
import Cover from '../cover'

import Scrollchor from 'react-scrollchor'
import Masthead from '@ta-interaktiv/react-masthead'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import { Footer } from '@ta-interaktiv/react-footer'

import UserFeedback from '@ta-interaktiv/react-user-feedback'
import Waypoint from 'react-waypoint'

type Props = {
  articleId: string
}

class AppComponent extends React.Component<Props> {
  static defaultProps = {
    articleId: '28428512'
  }

  constructor (props) {
    super(props)
  }

  render () {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead articleId={this.props.articleId} />

        <header className='ui vertical fitted segment' id='start'>
          {/* <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              Ma vie d’arbitre
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
                Parce que c’est tellement facile, les lieux communs se bousculent. Sur tous
                les terrains de foot, les mêmes rengaines, avec des insultes à peine
                voilées, qui visent un homme, un seul, celui sans lequel pourtant rien ne
                serait possible. Être arbitre n’est plus une vocation, c’est devenu un sacerdoce.
              </div>
            </h2>
            <p className='ta author'>
              <strong>Daniel Visentini</strong>
            </p>
          </div> */}
          <Cover
            title='Ma vie d’arbitre'
            subtitle='Rencontre avec Pierre Collart, jeune arbitre genevois prometteur, qui raconte sa passion'
          />
        </header>

        <main className='ui vertical fitted segment' style={{background: "#2b2c2d"}}>
          <div
            className='ui text container'
            style={{ marginBottom: '3em' }}
          >
            <p className="ta author" style={{marginBottom: "2.4em", paddingTop: "2em", color: "white"}}>
              Texte: <b>Daniel Visentini</b><br/>
              Vidéos: <b>Georges Cabrera</b>
            </p>
            <p className='introKategorie'>
              Pierre Collart a 24 ans, il était jusqu'à cet été arbitre en 2e ligue genevoise, une passion
              qu’il cultive depuis 2011 déjà. Ce directeur de jeu prometteur a désormais intégré un cursus
              de trois ans en rejoignant la Referee Academy, un centre de formation et de perfectionnement
              pour les arbitres qui ont du potentiel. Il officie maintenant en 2e ligne interrégionale.
              Les risques du métier existent: en 2018, un arbitre a été tabassé en 5e ligue, cette
              violence inadmissible qui enfle a conduit à une grève du corps arbitral genevois sur
              tout un week-end, l’automne dernier. Un geste fort.
            </p>
            <p className='introKategorie'>
              Que pense Pierre Collart de tout cela, de cette violence qui menace, justement? De
              son rôle, de son regard sur sa position au cœur du terrain? Nous l’avons suivi
              un dimanche matin. C’était à l’occasion d’une rencontre de 2e ligue entre Onex
              et Aïre-le-Lignon. Pierre Collart était entouré de ses deux assistants. Cet
              étudiant en lettres (français et histoire) raconte sa passion et on découvre
              son univers de l’intérieur, de son arrivée au stade au débriefing qui suit avec
              son coach de la commission d’arbitrage de l’ACGF.
            </p>
            <p>
              <Scrollchor to='#video-1' className='recherche-link' animate={{offset: -50}}>
                <i class="grey film icon"></i>
                Voir la vidéo&nbsp;
                <i className='small double angle down icon' />
              </Scrollchor>
            </p>
          </div>
          
          <div className='ui container' id="video-1">
            <VideoPlayer
              mp4Mobile={'https://podcast.newsnetz.tv/podcast/news/403295h.mp4'}
              mp4={'https://podcast.newsnetz.tv/podcast/news/403295h.mp4'}
              poster={'https://server025.newsnetz.tv/403295/frame-1-403295.jpg'}
              trackingID='01 - La vocation'
            />
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='hypercars'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>1. L'arrivée au stade</span>
              </h2>
              <Scrollchor to='#bugattis' className='upScrollchor white'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div
                    className='arrow-text mobile hidden'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    revenir
                  </div>{' '}
                  <i className='chevron up icon white' />
                </div>
              </Scrollchor>
            </div>

            <p className='introKategorie'>
              Un match, comme pour ceux qui vont le jouer, commence dès le portail
              du stade franchi. En 2e ligue, c’est un trio arbitral qui officie. Pierre
              Collart arrive près de deux heures avant le coup d’envoi sur place, ici à
              Onex, où il retrouve ses deux assistants. Direction le petit vestiaire
              réservé. Le rituel s’installe. Ils se changent. Ils ont toujours deux ou
              trois maillots de couleurs différentes pour s’adapter aux maillots des
              deux équipes, mais aussi aux couleurs portées par les deux gardiens de but.
            </p>
            <p>
              <Scrollchor to='#video-2' className='recherche-link' animate={{offset: -50}}>
                <i class="grey film icon"></i>
                Voir la vidéo&nbsp;
                <i className='small double angle down icon' />
              </Scrollchor>
            </p>
          </div>

          <div className='ui container' id="video-2">
            <VideoPlayer
              mp4Mobile={'https://podcast.newsnetz.tv/podcast/news/403285h.mp4'}
              mp4={'https://podcast.newsnetz.tv/podcast/news/403285h.mp4'}
              poster={'https://server025.newsnetz.tv/403285/frame-6-403285.jpg'}
              trackingID='02 - arrivée au stade'
            />
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='ferraris'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>2. Le vestiaire</span>
              </h2>
              <Scrollchor to='#hypercars' className='upScrollchor white'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div
                    className='arrow-text mobile hidden'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    revenir
                  </div>{' '}
                  <i className='chevron up icon white' />
                </div>
              </Scrollchor>
            </div>

            <p className='introKategorie'>
              Le moment du coup d’envoi se rapproche, on passe aux choses sérieuses. Le
              responsable du FC Onex vient régler l’arbitre, comme c’est la
              coutume: ici, c’est 140 francs pour le directeur de jeu et 110 francs
              pour chacun de ses assistants. On ne devient pas arbitre pour
              s’enrichir… Ensuite, Pierre Collart donne les consignes à ses deux
              collègues, dans la répartition des tâches. Cela comprend aussi la
              gestuelle, afin de prendre la bonne décision le plus vite possible
              dans le feu de l’action.
            </p>
            <p>
              <Scrollchor to='#video-3' className='recherche-link' animate={{offset: -50}}>
                <i class="grey film icon"></i>
                Voir la vidéo&nbsp;
                <i className='small double angle down icon' />
              </Scrollchor>
            </p>
          </div>

          <div className='ui container' id="video-3">
            <VideoPlayer
              mp4Mobile={'https://podcast.newsnetz.tv/podcast/news/403287h.mp4'}
              mp4={'https://podcast.newsnetz.tv/podcast/news/403287h.mp4'}
              poster={'https://server025.newsnetz.tv/403287/frame-3-403287.jpg'}
              trackingID='03 - Les vestiaire'
            />
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='lamborghinis'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>3. L'échauffement</span>
              </h2>
              <Scrollchor to='#ferraris' className='upScrollchor white'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div
                    className='arrow-text mobile hidden'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    revenir
                  </div>{' '}
                  <i className='chevron up icon white' />
                </div>
              </Scrollchor>
            </div>

            <p className='introKategorie'>
              Le trio est prêt. Avec ses deux assistants, Pierre Collart part
              s’échauffer. Un arbitre central dépasse régulièrement les 10
              kilomètres parcourus lors d’un match, dont près de 900 mètres
              à très haute intensité. «L’entraînement se fait durant la
              semaine, explique Pierre. J’aime bien courir seul. Je m’exerce
              aussi aux sprints, je fais du cardio, du gainage aussi. Et puis
              je circule à vélo. Cela aide également.» L’échauffement d’avant
              match, c’est aussi le moment de la concentration. Ensuite, il
              s’agit d’aller faire l’appel dans le vestiaire des équipes.
            </p>
            <p>
              <Scrollchor to='#video-4' className='recherche-link' animate={{offset: -50}}>
                <i class="grey film icon"></i>
                Voir la vidéo&nbsp;
                <i className='small double angle down icon' />
              </Scrollchor>
            </p>
          </div>

          <div className='ui container'  id="video-4">
            <VideoPlayer
              mp4Mobile={'https://podcast.newsnetz.tv/podcast/news/403289h.mp4'}
              mp4={'https://podcast.newsnetz.tv/podcast/news/403289h.mp4'}
              poster={'https://server025.newsnetz.tv/403289/frame-22-403289.jpg'}
              trackingID='04 - Échauffement'
            />
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='porsches'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>4. Le match</span>
              </h2>
              <Scrollchor to='#lamborghinis' className='upScrollchor white'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div
                    className='arrow-text mobile hidden'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    revenir
                  </div>{' '}
                  <i className='chevron up icon white' />
                </div>
              </Scrollchor>
            </div>

            <p className='introKategorie'>
              C’est le moment du match. Les équipes se saluent et Pierre Collart
              est immédiatement aux commandes. Il doit rester près du ballon, de
              l’action, sans interférer. Il doit se montrer clair dans ses décisions
              pour qu’elles ne souffrent pas la moindre contestation. Tout cela
              s’apprend. Il est d’ailleurs observé par un coach depuis la touche, Saimir
              Reli, de la commission d’arbitrage de l’association cantonale genevoise
              de football (ACGF). Ce dernier note tout, pour le bien et la progression de
              Pierre Collart.
            </p>
            <p>
              <Scrollchor to='#video-5' className='recherche-link' animate={{offset: -50}}>
                <i class="grey film icon"></i>
                Voir la vidéo&nbsp;
                <i className='small double angle down icon' />
              </Scrollchor>
            </p>
          </div>

          <div className='ui container' id="video-5">
            <VideoPlayer
              mp4Mobile={'https://podcast.newsnetz.tv/podcast/news/403291h.mp4'}
              mp4={'https://podcast.newsnetz.tv/podcast/news/403291h.mp4'}
              poster={'https://server025.newsnetz.tv/403291/frame-21-403291.jpg'}
              trackingID='05 - Le match'
            />
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='astonmartins'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>5. Retour au vestiaire</span>
              </h2>
              <Scrollchor to='#porsches' className='upScrollchor white'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div
                    className='arrow-text mobile hidden'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    revenir
                  </div>{' '}
                  <i className='chevron up icon white' />
                </div>
              </Scrollchor>
            </div>

            <p className='introKategorie'>
              Le match est terminé. Sans attendre, c’est immédiatement l’instant du
              débriefing avec l’expert qui a suivi son poulain. Saimir Reli n’est pas
              là pour brimer Pierre Collart. Au contraire. Il s’agit de relever avec
              lui les sensations, les moments particuliers qui ont rythmé la partie, de
              discuter des décisions et de la manière de les prendre aussi. Pierre est
              attentif, il donne aussi son ressenti et on remarque déjà, quelques minutes
              à peine après le coup de sifflet final, son aptitude à prendre du recul sur
              sa propre performance d’arbitre. Il est noté par Saimir Reli. Il s’est fait
              l’auteur d’une belle prestation et obtient logiquement la meilleure note
              pour son potentiel de développement, la note A.
            </p>
            <p>
              <Scrollchor to='#video-6' className='recherche-link' animate={{offset: -50}}>
                <i class="grey film icon"></i>
                Voir la vidéo&nbsp;
                <i className='small double angle down icon' />
              </Scrollchor>
            </p>
          </div>

          <div className='ui container' id="video-6">
            <VideoPlayer
              mp4Mobile={'https://podcast.newsnetz.tv/podcast/news/403293h.mp4'}
              mp4={'https://podcast.newsnetz.tv/podcast/news/403293h.mp4'}
              poster={'https://server025.newsnetz.tv/403293/frame-16-403293.jpg'}
              trackingID='06 - Retour au vestiaire'
            />
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <p className='introKategorie'>
              Pierre Collart est un jeune arbitre très prometteur. Il a moins besoin
              d’insultes ou de critiques stupides que de soutien dans l’exercice de sa
              passion. C’est le message le plus important qui transpire de ce dimanche
              passé en sa compagnie.
            </p>
          </div>

        </main>
        <div>
          <Footer
            mailTo="daniel.visentini@agencesportcenter.ch"
            locale='fr'
            hidePortfolioTeaser
            articleId={this.props.articleId}
            starColor='yellow'
            questions={[
              'Ce contenu était-il informatif?',
              'Etait-il divertissant?',
              'La mise en forme vous plaît-elle?'
            ]}
            credits={[
              ['Texte', 'Daniel Visentini'],
              ['Vidéos', 'Georges Cabrera'],
              ['Conception', 'Mathieu Rudaz']
            ]}
          >
          </Footer>
        </div>
      </div>
    )
  }
}

export default hot(module)(AppComponent)
